import { render, staticRenderFns } from "./Discussionpage.vue?vue&type=template&id=ec86cb80"
import script from "./Discussionpage.vue?vue&type=script&lang=js"
export * from "./Discussionpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports